import React from 'react';
import { Button, Steps, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import type { SubAccountStatus } from '../../services/appotapaySubAccountsService';

const { Link: TextLink } = Typography;

const APPOTAPAY_PORTAL_URL =
  'https://partner.appotapay.com/master-merchant/sub-account';

type Props = {
  status?: SubAccountStatus | null;
  hasCredentials?: boolean;
  merchantId?: number;
  onEnterCredentials?: () => void;
  compact?: boolean;
};

function currentStepIndex(
  status?: SubAccountStatus | null,
  hasCredentials?: boolean
): number {
  if (status === 'ACTIVE' && hasCredentials) return 3;
  if (hasCredentials) return 2;
  if (status === 'PENDING_ACTIVATION') return 1;
  return 0;
}

export function AppotaPayReferActivationFlow({
  status,
  hasCredentials,
  merchantId,
  onEnterCredentials,
  compact = false,
}: Props) {
  const step = currentStepIndex(status, hasCredentials);

  const items = [
    {
      title: 'Duyệt KYC trên AnGi',
      description: compact
        ? undefined
        : 'Admin duyệt hồ sơ trên AnGi — không gọi AppotaPay',
      status: (step >= 1 ? 'finish' : 'wait') as 'finish' | 'wait',
    },
    {
      title: 'Tạo REFER trên portal AppotaPay',
      description: compact ? undefined : (
        <span>
          Vận hành vào Master Merchant → Sub Merchant, tạo merchant loại{' '}
          <strong>REFER</strong>.{' '}
          <TextLink href={APPOTAPAY_PORTAL_URL} target="_blank">
            Mở portal AppotaPay <LinkOutlined />
          </TextLink>
        </span>
      ),
      status: (step >= 2 ? 'finish' : step === 1 ? 'process' : 'wait') as
        | 'finish'
        | 'process'
        | 'wait',
    },
    {
      title: 'Nhập credentials trên AnGi',
      description: compact ? undefined : (
        <span>
          AppotaPay gửi refer_id + partner_code + api_key + secret_key → admin
          nhập tại đây → merchant <strong>ACTIVE</strong>.
          {merchantId && onEnterCredentials ? (
            <>
              {' '}
              <Button
                type="link"
                size="small"
                style={{ padding: 0 }}
                onClick={onEnterCredentials}
              >
                Nhập credentials
              </Button>
            </>
          ) : null}
        </span>
      ),
      status: (step >= 3 ? 'finish' : step === 2 ? 'process' : 'wait') as
        | 'finish'
        | 'process'
        | 'wait',
    },
  ];

  return (
    <Steps
      direction={compact ? 'horizontal' : 'vertical'}
      size="small"
      current={Math.min(step, 2)}
      items={items}
      style={{ marginBottom: compact ? 0 : 8 }}
    />
  );
}

export { APPOTAPAY_PORTAL_URL };
